import { useState, useEffect } from 'react';
import { TBillingLeadGenFeeItem, TGetPaymentBillingLeadgenFeeList } from 'types/financials';
import { getPaymentBillingLeadgenFeeList, getPaymentBillingPracticeLeadgenFeeList } from 'api/financials';

const usePaymentBillingLeadgenFeeList = (
    param?: Partial<TGetPaymentBillingLeadgenFeeList>,
    isPractice = false,
): [
    TBillingLeadGenFeeItem[] | undefined,
    number,
    boolean,
    (param?: Partial<TGetPaymentBillingLeadgenFeeList>) => void,
] => {
    const [data, setData] = useState<TBillingLeadGenFeeItem[]>();
    const [total, setTotal] = useState<number>(0);
    const [loading, setLoading] = useState<boolean>(false);

    const fetchData = async (para: Partial<TGetPaymentBillingLeadgenFeeList> = {}) => {
        try {
            setLoading(true);
            const request = isPractice ? getPaymentBillingPracticeLeadgenFeeList : getPaymentBillingLeadgenFeeList;
            const res = await request({
                current: 1,
                size: 10,
                ...para,
            });
            if (!res.error) {
                const list = res.data?.data?.records || [];
                const amount = res.data?.data?.total;
                setTotal(amount || 0);
                setData(list);
            }
        } catch (err) {
            console.error('Payment list fetch error:', err);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchData(param);
    }, []);

    return [data, total, loading, fetchData];
};

export default usePaymentBillingLeadgenFeeList;
